@if (workspace) {
  <div
    class="modal-content"
    *let="isAddingWorkspaceDocuments$ | async as addingDocuments"
    [ngClass]="{ 'parent-modal-shadowed': isBulkEditModalOpen }"
  >
    <div class="modal-header">
      <h5 class="modal-title pull-left">
        {{ title }}
      </h5>
      <mat-icon
        (click)="onCancel()"
        svgIcon="close"
        [ngClass]="{ disabled: !!addingDocuments }"
      ></mat-icon>
    </div>

    <div class="modal-body">
      <div class="row" [class.d-none]="isSetDocumentPropertiesStep">
        <div class="col-sm-4 col-md-3 no-wrap">
          {{ 'workspaces.workspaceName' | transloco }}: {{ workspace.name }}
        </div>
      </div>

      <div class="row">
        <div class="col">
          @if (isSelectDocumentsStep) {
            {{ 'workspaces.workspaceDocuments' | transloco }}
          }
          @if (isSetDocumentPropertiesStep) {
            {{ 'workspaces.documentDetails' | transloco }}
          }
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-tab-group
            class="common-app-tabs"
            mat-stretch-tabs="false"
            mat-align-tabs="start"
            animationDuration="0ms"
            [class.d-none]="isHideTabs"
          >
            <mat-tab label="{{ 'workspaces.upload' | transloco }}">
              @if (isSelectDocumentsStep) {
                <div class="row" [class.d-none]="isFileSelected">
                  <div class="col">
                    @if (canUploadFiles) {
                    <ngx-file-drop
                      #fileDropRef
                      (onFileDrop)="dropped($event)"
                      [multiple]="true"
                      accept="{{ constants.baselineDocsFileUploaderAcceptedFormats.join(',') }}"
                    >
                      <ng-template
                        ngx-file-drop-content-tmp
                        let-openFileSelector="openFileSelector"
                      >
                        <p>
                          {{ 'text.dragAndDropMulti' | transloco }}
                        </p>
                        <p>
                          <button type="button" (click)="openFileSelector()">
                            {{ 'buttons.browse' | transloco }}
                          </button>
                        </p>
                      </ng-template>
                    </ngx-file-drop>
                    }
                    <span class="supportedFormats">
                      {{ 'text.supportedFormats' | transloco }}
                    </span>
                  </div>
                </div>

                <div class="row" *ngIf="maxFileCountError">
                  <div class="col">{{ 'errors.maxFileCountError' | transloco }}</div>
                </div>

                @if (isFileSelected) {
                  <div class="row">
                    <div class="col files-list">
                      @for (item of files; track item.relativePath; let i = $index) {
                        <div class="file-name">
                          <span class="file-name__text">{{ item.relativePath }}</span>
                          <button
                            *ngIf="canUploadFiles"
                            type="button"
                            class="file-name__remove"
                            (click)="onRemoveFile(i)"
                            aria-label="Remove file"
                          >
                            <mat-icon svgIcon="close"></mat-icon>
                          </button>
                        </div>
                      }
                    </div>
                  </div>

                  <div class="row">
                    <div class="col p-0">
                      @if (canUploadFiles) {
                      <app-button
                        [type]="btnTypes.Stroked"
                        icon="add"
                        label="{{ 'buttons.addMore' | transloco }}"
                        [size]="btnSizes.Basic"
                        (onClick)="onAddMoreFiles()"
                      ></app-button>
                      }
                    </div>
                  </div>
                }
              }
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>

      @if (isSetDocumentPropertiesStep) {
        <div class="row mt-2">
          <div class="col">{{ 'workspaces.documentDetailsExtraText' | transloco }}</div>
        </div>

        @if (canWrite) {
        <div
          class="mt-4 row-adaptive operations-btns edit-fieldset"
          [ngClass]="{ 'visible-flex': isAnySelectedWorkspaceDocuments }"
        >
          <span class="edit-fieldset-legend">{{
            'labels.bulkEditFieldsetLegend' | transloco
          }}</span>

          <div class="col-adaptive operation-btn-col">
            <app-button
              [icon]="'stacks'"
              [type]="btnTypes.Icon_Stroked"
              [size]="btnSizes.InOperationRow"
              [label]="'buttons.editDocType' | transloco"
              (onClick)="bulkEditDocType()"
            ></app-button>
          </div>

          <div class="col-adaptive operation-btn-col">
            <app-button
              [icon]="'compare_arrows'"
              [type]="btnTypes.Icon_Stroked"
              [size]="btnSizes.InOperationRow"
              [label]="'buttons.editPosition' | transloco"
              (onClick)="bulkEditPosition()"
            ></app-button>
          </div>

          <div class="col-adaptive operation-btn-col">
            <app-button
              [icon]="'globe'"
              [type]="btnTypes.Icon_Stroked"
              [size]="btnSizes.InOperationRow"
              [label]="'buttons.editLanguage' | transloco"
              (onClick)="bulkEditLanguage()"
            ></app-button>
          </div>
        </div>
        }

        <div
          class="mt-2 row-adaptive selections-btns"
          [ngClass]="{ 'visible-flex': isAnySelectedWorkspaceDocuments }"
        >
          <div class="col-adaptive operation-btn-col">
            <span class="selected-items-count-info">
              <span class="text">
                <b>{{ selectedWorkspaceDocumentsCount }}</b>
                {{ 'text.countOfSelectedDocs' | transloco }}
              </span>
            </span>
          </div>
          <div class="col-adaptive operation-btn-col" *ngIf="workspaceDocumentsCount > 1">
            <app-button
              [type]="btnTypes.Link"
              [size]="btnSizes.InOperationRow"
              [label]="'buttons.selectAllDocs' | transloco: { count: workspaceDocumentsCount }"
              (onClick)="selectAllWorkspaceDocuments()"
            ></app-button>
          </div>
          <div class="col-adaptive operation-btn-col">
            <app-button
              [type]="btnTypes.Link"
              [size]="btnSizes.InOperationRow"
              [label]="'buttons.unselectAll' | transloco"
              (onClick)="resetWorkspaceDocumentsSelections()"
            ></app-button>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col">
            <app-client-side-inline-edit-data-table
              [columns]="workspaceDocumentsColumns"
              [data]="workspaceDocumentsForEdit"
              [selectionEnabled]="canWrite"
              [selectFieldName]="'id'"
              [selectedIds]="selectedWorkspaceDocumentIds"
              (dataChange)="onWorkspaceDocumentsDataChange($event)"
              (validChange)="onWorkspaceDocumentsValidityChange($event)"
              (selectedIdsChange)="onWorkspaceDocumentsSelectionChange($event)"
            ></app-client-side-inline-edit-data-table>
          </div>
        </div>
      }

      <div class="row" *ngIf="wrongFileType">
        <div class="col">
          <app-alert [type]="alertTypes.Error">
            {{ 'errors.wrongFileTypeDocxPdf' | transloco }}
          </app-alert>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <app-button
        [type]="btnTypes.Stroked"
        [icon]="'chevron_left'"
        class="back"
        label="{{ 'buttons.back' | transloco }}"
        [size]="btnSizes.Basic"
        [class.d-none]="isSelectDocumentsStep"
        [disabled]="!!addingDocuments"
        (onClick)="onBack()"
      ></app-button>
      <app-button
        *ngIf="canWrite"
        [type]="btnTypes.Flat"
        label="{{ 'dataTableLanguageSettings.paginate.next' | transloco }}"
        [disabled]="!!addingDocuments || !canUploadFiles"
        [class.d-none]="isSetDocumentPropertiesStep"
        [size]="btnSizes.Basic"
        (onClick)="onNext()"
      ></app-button>
      <app-button
        *ngIf="canWrite"
        [type]="btnTypes.Flat"
        label="{{ 'buttons.save' | transloco }}"
        [disabled]="!isWorkspaceDocumentsTableValid || !!addingDocuments || !canUploadFiles"
        [class.d-none]="isSelectDocumentsStep"
        [size]="btnSizes.Basic"
        (onClick)="onConfirm()"
      ></app-button>
      <app-button
        [type]="btnTypes.Stroked"
        label="{{ 'buttons.cancel' | transloco }}"
        [disabled]="!!addingDocuments"
        [size]="btnSizes.Basic"
        (onClick)="onCancel()"
      ></app-button>
    </div>
  </div>
}
